import envs from "config/envs";

import * as S from "./HoldingGroup.style";

const HoldingGroup = () => {
  const GroupCompany = [
    {
      logo: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/logo_youse.webp`,
      alt: "Youse",
      content:
        "100% digital, a Youse revolucionou o jeito de vender seguro no País. Disruptiva, inovadora e com 50% da fatia do mercado, tornou-se um case de sucesso quando o assunto é experiência do cliente.",
      url: "https://www.youse.com.br/",
    },
    {
      logo: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/logo_caixa_seguradora.webp`,
      alt: "Caixa Seguradora",
      content:
        "Surgiu a partir da união entre duas gigantes: a CNP Assurances e a Caixa. Juntas, fazem a gestão dos seguros Habitacional e Residencial (comercializados até 2021) e do seguro Empresarial.",
      url: "https://www.caixaseguradora.com.br",
    },
  ];

  const titleHome = <>Nossas empresas</>;

  return (
    <S.Container>
      <S.Title variant="headline-02" color="primary">
        {titleHome}
      </S.Title>
      <div>
        {GroupCompany.map((company, index) => (
          <S.CardContainer key={index}>
            <S.CardContent>
              <S.CardImage
                width="auto"
                height="100%"
                src={company.logo}
                alt={company.alt}
              />
            </S.CardContent>
            <S.CardContent>
              <S.CardParagraph>{company.content}</S.CardParagraph>
              <S.ActionButton
                role="link"
                onClick={() =>
                  company.url && window.open(company.url, "_blank")
                }
                alt={`Saber mais sobre a ${company.alt}`}
              >
                Saiba mais
              </S.ActionButton>
            </S.CardContent>
          </S.CardContainer>
        ))}
      </div>
    </S.Container>
  );
};

export default HoldingGroup;
